import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const SewerTinderV3Guard = createFeatureGuard(Feature.SewerTinderV3);